import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

const links = [
  { label: "Land", href: "#chapter-land" },
  { label: "Luxury", href: "#chapter-luxury" },
  { label: "Wealth", href: "#chapter-wealth" },
  { label: "Insurance", href: "#chapter-insurance" },
  { label: "Commercial Property", href: "#chapter-commercial" },
  { label: "Employee Login", href: "/employee-login" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${scrolled ? "glass" : "bg-transparent"}`}
      data-testid="main-navbar"
    >
      <div className="max-w-[1600px] mx-auto flex items-center justify-between px-6 md:px-12 py-5">
        <Logo testId="nav-logo" />
        <nav className="hidden md:flex items-center gap-10" data-testid="nav-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`font-mono-lux text-[11px] uppercase tracking-[0.25em] transition-colors duration-300 ${
                l.label === "Employee Login" ? "text-[#C8A97E] hover:text-[#F8F9FA]" : "text-[#8A8D98] hover:text-[#C8A97E]"
              }`}
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </motion.header>
  );
};
